import { defineSlotRecipe } from "@chakra-ui/react"

const slotRecipes = {
    accordion: defineSlotRecipe({
        slots: ["root", "item", "itemTrigger", "itemContent", "itemIndicator"],
        base: {
            itemTrigger: {
                cursor: "pointer",
            },
        },
    }),
    field: defineSlotRecipe({
        slots: ["root", "label", "helperText", "errorText", "requiredIndicator"],
        base: {
            label: {
                fontSize: "md",
            },
        },
    }),
}

export default slotRecipes